(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('ReportFilterDialogController', ReportFilterDialogController);

    function ReportFilterDialogController($mdMedia, $mdDialog, $translate) {

        const vm = this;
        vm.$mdMedia = $mdMedia;

        vm.getDialogTitleText = function () {
            return $translate.instant('Choose the {{entity}} to report on', { entity: vm.entity || '' });
        };

        vm.onEntityFilterChanged = function ($event) {

            vm.filterRules = $event.rules;
        };

        vm.save = function () {

            return $mdDialog.hide({
                condition: 'AND',
                rules: vm.filterRules
            });
        };

        vm.cancel = $mdDialog.cancel;
    }
})();
